import { containerStyle } from '../../styles';

export default {
  container: {
    ...containerStyle
  },
  submit: {
    textTransform: 'uppercase',
    marginTop: 10
  }
};
